export var ACTION;
(function (ACTION) {
    ACTION["NAVIGATE_NEXT"] = "NAVIGATE_NEXT";
    ACTION["BUILD_LIST_ITEMS"] = "BUILD_LIST_ITEMS";
})(ACTION || (ACTION = {}));
